import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { GlobalVariables } from '../../../shared/model/global-variables';
import { environment } from 'src/environments/environment';
import { AuthenticateService } from 'src/app/shared/service/authenticate/authenticate.service';

@Component({
    selector: 'app-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UserMenuComponent implements OnInit {

  globalVar = new GlobalVariables();
  companies: any;
  companyName = '';
  isHomolog = environment.isHomolog;

  public userName: string = '';
  public companyTypeDescription: string = '';

  constructor(
    private _authService: AuthenticateService
  ) { }

  ngOnInit() {
    this.userName = this.globalVar.UserName || '';
    this.companyTypeDescription = this.globalVar.CompanyTypeDescription || '';
  }

  get userInitials(): string {
    if (!this.userName) return '?';
    return this.userName
      .split(' ')
      .slice(0, 2)
      .map(n => n[0])
      .join('')
      .toUpperCase();
  }

  setCompanyName() {
    const companies = this.globalVar.Companies;
    this.companies = companies ? JSON.parse(companies) : [];
    const company = this.companies.filter(x => x.id === +this.globalVar.UserCompanySelected);

    if (company !== null && company.length > 0) {
      return this.companyName = company[0].companyName;
    }
  }

  logout() {
    this.globalVar.resetAll();
    this._authService.logout();
  }

}
